/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */

/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/remote-desktop-exercise/v1.ts
 */
import { createValidator } from '../../helpers/validator';
export var RemoteDesktopExerciseV1Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    assignment: {
      type: 'string'
    },
    hint: {
      type: 'string'
    },
    question: {
      anyOf: [{
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['Open'],
            default: 'Open'
          },
          items: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                question: {
                  type: 'string'
                },
                solution: {
                  type: 'object',
                  properties: {
                    answer: {
                      type: 'string'
                    },
                    message: {
                      type: 'string'
                    },
                    pattern: {
                      type: 'string'
                    }
                  },
                  required: ['answer', 'message', 'pattern']
                },
                feedback: {
                  type: 'array',
                  items: {
                    type: 'object',
                    properties: {
                      message: {
                        type: 'string'
                      },
                      pattern: {
                        type: 'string'
                      }
                    },
                    required: ['message', 'pattern']
                  }
                }
              },
              required: ['question', 'solution', 'feedback']
            }
          }
        },
        required: ['flavor', 'items']
      }, {
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['PureMultipleChoice'],
            default: 'PureMultipleChoice'
          },
          question: {
            type: 'string',
            default: ''
          },
          possible_answers: {
            type: 'array',
            items: {
              type: 'string'
            }
          },
          feedback: {
            type: 'array',
            items: {
              type: 'string'
            }
          }
        },
        required: ['feedback', 'flavor', 'possible_answers'],
        title: 'PureMultipleChoice'
      }]
    }
  },
  required: ['assignment', 'chapter_id', 'course_id', 'hint', 'question', 'title', 'xp'],
  definitions: {}
};
export var isValidRemoteDesktopExerciseV1 = createValidator(RemoteDesktopExerciseV1Schema);
export var RemoteDesktopExerciseV1Definition = {
  schema: RemoteDesktopExerciseV1Schema,
  validate: isValidRemoteDesktopExerciseV1
};